<template>
    <div v-show="show" class="interviewCheck-container">
        <div style="position: absolute; top: -999999;" id="picBtn"></div>
        <div :class="{interviewCheckContent: true, on: type != 'noSelect'}">
            <div class="title">{{title}}</div>
            <img @click="close" class="close" src="./assets/close.png" alt="">
            <div v-if="type == 'noSelect' && mode != 'delay' && mode != 'back'" class="notice">
                <i></i>
                <p>领取前请检查确认设备和附件完好无缺，设备需要在任务结束<span>{{ config.set_device_outdate_alarm }}</span> 小时内归还!</p>
            </div>
            <div  v-if="type != 'noSelect'" class="selectContent">
                <ul>
                    <li v-for="item in expandDevice" :key="item.device_id">
                        <div class="l">
                            <i @click="item.selected = !item.selected" :class="{on: item.selected}"></i>
                            <p>{{item.type_title}}</p>
                        </div>
                        <div class="r">
                            <p class="n">{{item.device_name}}</p>
                            <p>{{item.msg}}</p>
                        </div>
                    </li>
                </ul>
            </div>
            <div v-if="type != 'noSelect'" class="selectBtn">
                <div @click="toggleAll" class="l">
                    <i :class="{on: selectAll}"></i>
                    <p>全选</p>
                    <span>(已选择{{selectNum}}个）</span>
                </div>
                <div @click="next" class="r">下一步</div>
            </div>
            <div v-if="type == 'noSelect'" class="content">
                <ul>
                    <li v-for="(item,index) in expandDevice" :key="item.device_id">
                        <div class="l">{{item.type_title}}</div>
                        <div v-if="mode == 'get'" class="r">
                            <p class="t">{{item.device_name}}</p>
                            <div class="row">
                                <p class="n">设备编号</p>
                                <p>{{item.idstring}}</p>
                            </div>
                            <div class="row">
                                <p class="n">其他附件</p>
                                <p>{{item.other_comment}}</p>
                            </div>
                        </div>
                        <div v-if="mode == 'back'" class="r">
                            <p class="t">{{item.device_name}}</p>
                            <div class="row">
                                <p class="n">到期时间</p>
                                <p>{{item.end}}</p>
                            </div>
                            <div class="row">
                                <p class="n">设备配件</p>
                                <p>{{item.other_comment}}</p>
                            </div>
                            <div class="uploadInfo">
                                <div class="row start">
                                    <p class="n">留言</p>
                                    <div class="textarea">
                                        <textarea placeholder="请备注归还给谁/放在哪里，若无人交接，务必拍照上传凭证。" maxlength="60" v-model="item.content"></textarea>
                                        <span>{{item.content.length}}/60</span>
                                    </div>
                                </div>
                                <div class="row">
                                    <p class="n">归还凭证</p>
                                    <div v-if="!item.isUpload" class="uploadBtn-container">
                                        <div @click="upload(index)" class="uploadBtn">
                                            <i></i>
                                            <span>上传凭证</span>
                                        </div>
                                        <span>支持扩展名：.jpg.png</span>
                                    </div>
                                    <div v-if="item.isUpload" class="uploadProgress-container">
                                        <i></i>
                                        <div class="uploadProgress">
                                            <div class="top">
                                                <div class="lt">{{item.name}}</div>
                                                <div @click="delUpload(index)" class="rt"></div>
                                            </div>
                                            <div v-if="item.progress" class="bottom">
                                                <div :style="'width:'+item.progressNum+'%'" class="g"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="mode == 'delay'" class="r">
                            <p class="t" style="margin-bottom: 5px">{{item.device_name}}</p>
                            <div class="row" style="margin-bottom: 16px">
                                <p class="n" style="margin: 0">{{item.msg}}</p>
                                <!-- <p class="n">2019-03-23  17:30</p> -->
                            </div>
                            <div class="uploadInfo">
                                <div class="row red">
                                    <p class="n">延期至</p>
                                    <el-date-picker
                                        popper-class="no-atTheMoment"
                                        :picker-options="item.pickerOption"
                                        v-model="item.date"
                                        type="datetime"
                                        value-format="yyyy-MM-dd HH:mm:ss"
                                        placeholder="选择日期时间">
                                    </el-date-picker>
                                </div>
                                <div class="row start">
                                    <p class="n">理由</p>
                                    <div class="textarea">
                                        <textarea maxlength="20" v-model="item.content"></textarea>
                                        <span>{{item.content.length}}/20</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                    <!-- <li>
                        <div class="l">录像机</div>
                        <div class="r">
                            <p class="t">1号摄像机</p>
                            <div class="row">
                                <p class="n">设备编号</p>
                                <p>S 10000003</p>
                            </div>
                            <div class="row">
                                <p class="n">其他附件</p>
                                <p>S 10000003</p>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="l">录像机</div>
                        <div class="r">
                            <p class="t">1号摄像机</p>
                            <div class="row">
                                <p class="n">设备编号</p>
                                <p>S 10000003</p>
                            </div>
                            <div class="row">
                                <p class="n">其他附件</p>
                                <p>S 10000003</p>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="l">录像机</div>
                        <div class="r">
                            <p class="t">1号摄像机</p>
                            <div class="row">
                                <p class="n">设备编号</p>
                                <p>S 10000003</p>
                            </div>
                            <div class="row">
                                <p class="n">其他附件</p>
                                <p>S 10000003</p>
                            </div>
                        </div>
                    </li> -->
                </ul>
            </div>
            <div v-if="type == 'noSelect'" @click="confirm" class="btn">确认</div>
        </div>
    </div>
</template>

<script>
import common from '@common/common'
import { apis } from '@common/config'
import * as config from '@common/config'

export default {
    watch: {
        value1(to) {
            console.log(to)
        },
        expandDevice: {
            handler(e) {
                let length = this.expandDevice.length
                let num = 0
                this.expandDevice.forEach(el => {
                    if(el.selected){
                        num ++
                    }
                })

                if(num == length){
                    this.selectAll = true
                }else{
                    this.selectAll = false
                }

                this.selectNum = num
            },
            immediate: true,
            deep: true
        }
    },
    data() {
        return {
            pickerOption: {
            },
            isLoading: false,
            uploadId: '',
            upLoadIndex: '9999',
            show: false,
            config: {},
            callback: null,
            title: '领取设备',
            value1: '',
            type: 'noSelect',
            mode: 'get',
            expandDevice: [],
            selectAll: false,
            selectNum: 0,
            picConfig: {
                browseFileId: 'picBtn',
                extFilters: ['.jpg', '.png', '.jpeg'],
                maxSize: 20*1024*1024,
                customered: true,
                autoUploading: true,
                multipleFiles: false,
                retryCount: 3,
                tokenURL: '',
                uploadURL: '',
                postVarsPerFile: {
                    appId: '',
                    appSecret: ''
                },
                onSelect: f => {
                    console.log(f)
                    // 视音频数量限制10个（待添加），超出：stream.stop(), stream.cancel()
                    setTimeout(() => {    
                        this.isLoading = true;  
                        this.expandDevice[this.upLoadIndex].name = f[0].name;
                        this.expandDevice[this.upLoadIndex].uploadId = f[0].id;
                        this.expandDevice[this.upLoadIndex].isUpload = true;
                        this.expandDevice[this.upLoadIndex].progress = true;
                        this.expandDevice[this.upLoadIndex].progressNum = 0;
                        // this.$emit('handleStart',f[0].name)
                    }, 0);
                },
                onComplete: (f) => {
                    this.isLoading = false;  
                    this.picStream.cancelOne(f.id);
                    this.expandDevice[this.upLoadIndex].url = JSON.parse(f.msg).targetPath;
                    this.expandDevice[this.upLoadIndex].progress = false;
                    this.expandDevice[this.upLoadIndex].progressNum = 0;
                    // const path = (JSON.parse(f.msg)).targetPath
                    // this.changeBg([f])
                },
                onUploadError: (f) => {
                    this.$toast("文件上传出错");
                },
                onMaxSizeExceed: (f) => {
                    this.$toast("文件大小超出上限");
                },
                onUploadProgress: f => {
                    console.log(f)
                    this.expandDevice[this.upLoadIndex].progress = true;
                    this.expandDevice[this.upLoadIndex].progressNum = f.percent;
                    // this.handleProgress(this.file.list, f);
                    // this.$emit('handleProgress',f)
                }
            }
        }
    },
    methods: {
        delUpload(index) {
            // console.log(this.file.list)
            if(this.expandDevice[index].uploadId){
                if(this.isLoading){
                    this.picStream.cancelOne(this.expandDevice[index].uploadId);
                }
                this.expandDevice[index].progressNum = 0
                this.expandDevice[index].progress = true
                this.expandDevice[index].isUpload = false;
                this.expandDevice[index].name = '';
                this.expandDevice[index].url = '';
            }
        },
        getAsperaConfig() {
            // 获取aspera上传配置
            return new Promise((resolve, reject) => {
                if(this.asperaConfig){
                    console.log(this.asperaConfig)
                    let r = this.asperaConfig;
                    // window._XN_upVdoTps = types.video // 视频格式前缀为source，此处为传入streamjs
                    // const filetypes = types.image.concat(types.video).concat(types.audio);
                    // this.file.config.extFilters = extFilters;

                    window._XN_upCfg = {
                        asperaPath: r.aspera_path,
                        httpPath: r.original_path,
                        fileNameId: r.filename_id
                    };
                    resolve(true)
                }else{
                    reject(false)
                }
            })
        },
        async load() {
            // 加载js文件
            // return common.load(config.streamjs)
            return this.getAsperaConfig().then(() => {
                return Promise.all([this.loadjs(), this.getConfig()]);
            });
        },
        loadjs() {
            // 加载js文件
            if (window.Stream) {
                return new Promise((r, j) => {
                r(true);
                });
            }

            return common.load(config.streamjs);
        },
        getConfig() {
            if(this.fileConfig){
                let r = this.fileConfig;
                this.baseUrl = r.url;
                this.appId = r.app_id;
                this.appSecret = r.app_secret;
                this.cancel_enable = r.cancel_enable;
                const dataConfig = {
                    tokenURL: this.baseUrl + config.apis.File_get_token,
                    uploadURL: this.baseUrl + config.apis.File_post,
                    postVarsPerFile: {
                        appId: this.appId,
                        appSecret: this.appSecret
                    }
                };
                Object.assign(this.picConfig, dataConfig, common.userKeys());
                return true;
            }
        },
        loadConfig() {
            return Promise.all([this.getConfig1(), this.getAsperaConfig1()]);
        },
        getConfig1() {
            return common.getFileConfigs().then(r => {
                if(r){
                    this.fileConfig = r;
                    return true;
                }
            });
        },
        getAsperaConfig1() {
            // 获取aspera上传配置
            return common.myFetch(apis.File_Aspera).then(r => {
                if (r) {
                    this.asperaConfig = r;
                    return true;
                }
            });
        },
        setConfig() {
            this.load().then(() => {
                console.log(87665)
                this.picStream = new Stream(this.picConfig)
                // this.configFile();
            });
        },
        upload(index) {
            this.upLoadIndex = index
            let picBtn = document.getElementById('picBtn');
            picBtn.click()
        },
        next() {
            let expandDevice = this.expandDevice
            let arr = []
            expandDevice.forEach(el => {
                if(el.selected){
                    arr.push(el)
                }
            })

            if(arr.length > 0){
                this.type = 'noSelect'
                if(this.mode == 'delay'){
                    arr.forEach(item => {
                        item.date = item.end
                        item.pickerOption = Object.assign({}, item.pickerOption, {
                            disabledDate: (time) => {  
                                return time.getTime() <= new Date(item.end)
                            }
                        })
                    })
                    this.title = '填写延期时间'
                }else{
                    this.mode = 'back'
                    this.title = '归还检查'
                }
                
                this.expandDevice = arr
            }else{
                this.$toast('请选择需要归还的设备')
            }
        },
        toggleAll() {
            let expandDevice = this.expandDevice
            if(this.selectAll){
                expandDevice.forEach(el => {
                    el.selected = false
                })
            }else{
                expandDevice.forEach(el => {
                    el.selected = true
                })
            }

            this.expandDevice = expandDevice
        },
        interviewReceive() {
            const data = {
                iview_id: this.config.id
            }

            common.myFetch(apis.Interview_receive, data)
                .then((data) => {
                this.$toast(data)
                this.show = false;
                this.callback(true)
                console.log(data)
            })
        },
        interviewDevice() {
            let expandDevice = this.expandDevice
            let arr = []

            expandDevice.forEach(el => {
                arr.push({
                    device_id: el.device_id,
                    iview_id: this.config.id,
                    task_id: el.task_id,
                    remark: el.content,
                    path: el.url
                })
            })

            console.log(arr)

            arr = JSON.stringify(arr)
            
            const info = {
                info: arr,
            }

            console.log(info)

            common.myFetch(apis.Return_device, info)
                .then((data) => {
                this.$toast(data)
                this.show = false;
                this.callback(true)
                console.log(data)
            })
        },
        interviewDelay() {
            let expandDevice = this.expandDevice
            let arr = []

            expandDevice.forEach(el => {
                arr.push({
                    device_id: el.device_id,
                    iview_id: this.config.id,
                    task_id: el.task_id,
                    remark: el.content,
                    end: el.date
                })
            })

            console.log(arr)

            arr = JSON.stringify(arr)
            
            const info = {
                info: arr,
            }

            console.log(info)

            common.myFetch(apis.Interview_delay, info)
                .then((data) => {
                this.$toast(data)
                this.show = false;
                this.callback(true)
                console.log(data)
            })
        },
        open(config, callback) {
            this.loadConfig().then(() => {
                console.log('success')
                this.setConfig()
            })
            this.type = config.type
            this.mode = config.mode
            this.title = config.title
            this.config = config;
            this.expandDevice = config.expandDevice
            this.callback = callback;
            this.show = true;
        },
        confirm() {
            if(this.config.mode == 'get'){
                this.interviewReceive()
            }else if(this.config.mode == 'back'){
                this.interviewDevice()
            }else if(this.config.mode == 'delay'){
                let expandDevice = this.expandDevice
                let empty = false
                let early = false
                expandDevice.forEach(el => {
                    if(el.date == ''){
                        empty = true 
                    }

                    if(new Date(el.date) <= new Date(el.end)) {
                        early = true
                    }
                })
                if(!empty && !early){
                    this.interviewDelay()
                }else if(empty){
                    this.$toast('延期时间不能为空')
                }else if(early){
                    this.$toast('延期时间不能早于等于到期时间')
                }
            }
        },
        cancel() {
            this.show = false;
            this.callback(false)
        },
        close() {
            this.cancel()
        }
    }
}
</script>

<style lang="less">
    .interviewCheck-container {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1001;
        background-color: rgba(50, 59, 75, 0.3);
        backdrop-filter: blur(1.6px);

        .interviewCheckContent {
            position: absolute;
            top: 50%;
            left: 50%;
            width: 622px;
            height: 584px;
            display: flex;
            flex-direction: column;
            margin-left: -311px;
            margin-top: -292px;
            background: #F9F9F9;
            box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
            border-radius: 4px;
            // padding: 20px 30px 21px;
            // box-sizing: border-box;

            &.on {
                width: 480px;
                height: 524px;
                margin-left: -240px;
                margin-top: -262px;
            }

            .notice {
                display: flex;
                align-items: center;
                width: 562px;
                height: 40px;
                background: #FFFAEB;
                border-radius: 4px;
                margin: 0 auto 14px;
                padding: 0 30px;
                box-sizing: border-box;

                i {
                    display: block;
                    width: 14px;
                    height: 14px;
                    background: url('./assets/notice.png') no-repeat;
                    background-size: 100% 100%;
                    background-position: center center;
                    margin-right: 8px;
                }

                p {
                    display: flex;
                    align-items: center;
                    font-size: 14px;
                    color: #666666;

                    span {
                        color: #41B48C;
                        display: block;
                        margin: 0 5px 0 5px;
                    }
                }
            }

            .title {
                width: 100%;
                font-size: 24px;
                line-height: 33px;
                color: #050F0F;
                margin-bottom: 20px;
                padding: 20px 30px 0px;
                box-sizing: border-box;
            }

            .close {
                position: absolute;
                top: 20px;
                right: 30px;
                width: 21px;
                height: 21px;
                user-select: none;
                cursor: pointer;
            }

            .selectContent {
                display: flex;
                flex-direction: row;
                width: 100%;
                height: 378px;
                overflow-y: auto;
                padding: 0 30px;
                box-sizing: border-box;

                &::-webkit-scrollbar {
                    width: 6px;
                    height: 0;
                    margin-right: 2px;
                }
                &::-webkit-scrollbar-thumb {
                    background: rgba(185, 195, 195, 0.5);
                    border-radius: 4px;
                }

                ul {
                    width: 100%;
                    display: flex;
                    flex-direction: column;

                    li {
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        width: 100%;
                        margin-bottom: 19px;

                        &:nth-last-of-type(1) {
                            margin-bottom: 0;
                        }
                    }
                }

                .l {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    height: 45px;

                    i {
                        display: block;
                        width: 18px;
                        height: 18px;
                        background: url('./assets/select.png') no-repeat;
                        background-size: 100% 100%;
                        background-position: center center;

                        &.on {
                            background: url('./assets/selectOn.png') no-repeat;
                            background-size: 100% 100%;
                            background-position: center center;
                        }
                    }

                    p {
                        width: 80px;
                        height: 45px;
                        line-height: 45px;
                        text-align: center;
                        background: rgba(65, 180, 140, 0.1);
                        border-radius: 2px;
                        font-size: 14px;
                        color: #41B48C;
                        font-weight: bold;
                        margin: 0 20px 0 14px;
                    }
                }

                .r {
                    display: flex;
                    flex-direction: column;
                    flex: 1;
                    height: fit-content;
                    padding-bottom: 19px;
                    border-bottom: 1px solid #DCDCDC;
                    box-sizing: border-box;

                    p {
                        font-size: 14px;
                        line-height: 20px;
                        color: #B9C3C3;

                        &.n {
                            font-size: 14px;
                            line-height: 20px;
                            color: #050F0F;
                            margin-bottom: 5px;
                            font-weight: bold;
                        }
                    }
                }
            }

            .selectBtn {
                width: 100%;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
                padding: 0 30px;
                box-sizing: border-box;
                margin-top: 20px;

                .l {
                    display: flex;
                    flex-direction: row;
                    align-items: center;

                    i {
                        display: block;
                        width: 18px;
                        height: 18px;
                        background: url('./assets/select.png') no-repeat;
                        background-size: 100% 100%;
                        background-position: center center;
                        user-select: none;
                        cursor: pointer;

                        &.on {
                            background: url('./assets/selectOn.png') no-repeat;
                            background-size: 100% 100%;
                            background-position: center center;
                        }
                    }

                    p {
                        font-size: 14px;
                        line-height: 20px;
                        color: #050F0F;
                        margin: 0 8px 0 10px;
                    }

                    span {
                        font-size: 13px;
                        color: #B9C3C3;
                    }
                }

                .r {
                    width: 120px;
                    height: 40px;
                    line-height: 40px;
                    text-align: center;
                    background: #41B48C;
                    border-radius: 25px;
                    font-size: 14px;
                    color: #FFFFFF;
                    user-select: none;
                    cursor: pointer;
                }
            }

            .content {
                width: 100%;
                flex: 1;
                min-height: 0;
                overflow-y: auto;
                padding: 0 30px;
                box-sizing: border-box;

                &::-webkit-scrollbar {
                    width: 6px;
                    height: 0;
                    margin-right: 2px;
                }
                &::-webkit-scrollbar-thumb {
                    background: rgba(185, 195, 195, 0.5);
                    border-radius: 4px;
                }

                ul {
                    display: flex;
                    flex-direction: column;

                    li {
                        display: flex;
                        flex-direction: row;
                        width: 100%;
                        padding: 20px;
                        box-sizing: border-box;
                        background: #EFF0F0;
                        border-radius: 10px;
                        margin-bottom: 14px;

                        &:nth-last-of-type(1) {
                            margin-bottom: 0;
                        }

                        .l {
                            width: 80px;
                            height: 20px;
                            line-height: 20px;
                            text-align: center;
                            font-size: 14px;
                            color: #41B48C;
                            font-weight: bold;
                            background: rgba(65, 180, 140, 0.1);
                            border-radius: 2px;
                            margin-right: 16px;
                        }

                        .r {
                            display: flex;
                            flex-direction: column;
                            flex: 1;

                            .t {
                                font-size: 14px;
                                line-height: 20px;
                                color: #050F0F;
                                font-weight: bold;
                                margin-bottom: 16px;
                            }

                            & > .row {
                                display: flex;
                                flex-direction: row;
                                align-items: center;
                                margin-bottom: 10px;

                                .n {
                                    font-size: 14px;
                                    line-height: 20px;
                                    color: #829191;
                                    margin-right: 20px;
                                }

                                & > p {
                                    font-size: 14px;
                                    line-height: 20px;
                                    color: #050F0F;
                                    font-weight: bold;
                                }

                                

                                &:nth-last-of-type(1) {
                                    margin-bottom: 0;
                                }
                            }

                            .uploadInfo {
                                display: flex;
                                flex-direction: column;
                                width: 100%;
                                padding-top: 15px;
                                border-top: 1px solid #DCDCDC;
                                box-sizing: border-box;

                                & > .row {
                                    display: flex;
                                    flex-direction: row;
                                    align-items: center;
                                    margin-bottom: 10px;

                                    &.start {
                                        align-items: flex-start;
                                    }

                                    &.red {
                                        position: relative;

                                        &:after {
                                            position: absolute;
                                            top: 6px;
                                            left: -14px;
                                            display: block;
                                            content: '*';
                                            font-size: 24px;
                                            color: #FF555A;
                                        }
                                    }

                                    .el-date-editor {
                                        flex: 1;
                                    }

                                    .n {
                                        width: 68px;
                                        font-size: 14px;
                                        line-height: 20px;
                                        color: #829191;
                                        margin-right: 15px;
                                    }

                                    & > p {
                                        font-size: 14px;
                                        line-height: 20px;
                                        color: #050F0F;
                                        font-weight: bold;
                                    }

                                    .textarea {
                                        position: relative;
                                        flex: 1;
                                        height: 100px;

                                        span {
                                            position: absolute;
                                            bottom: 10px;
                                            right: 14px;
                                            font-size: 14px;
                                            color: #B9C3C3;
                                            font-weight: 500;
                                        }
                                    }

                                    textarea {
                                        width: 100%;
                                        height: 100%;
                                        background: #FFFFFF;
                                        border-radius: 4px;
                                        border: 1px solid #DCDCDC;
                                        resize: none;
                                        padding: 5px 14px;
                                        box-sizing: border-box;

                                        &::-webkit-scrollbar {
                                            width: 6px;
                                            height: 0;
                                            margin-right: 2px;
                                        }
                                        &::-webkit-scrollbar-thumb {
                                            background: rgba(185, 195, 195, 0.5);
                                            border-radius: 4px;
                                        }

                                        &:focus {
                                            border: 1px solid #41B48C;
                                        }

                                        &::placeholder {
                                            color: #B9C3C3;
                                        }
                                    }

                                    .uploadBtn-container {
                                        display: flex;
                                        flex-direction: row;
                                        align-items: center;

                                        .uploadBtn {
                                            display: flex;
                                            flex-direction: row;
                                            justify-content: center;
                                            align-items: center;
                                            width: 112px;
                                            height: 30px;
                                            background: rgba(65, 180, 140, 0.15);
                                            border-radius: 4px;
                                            border: 1px solid rgba(65, 180, 140, 0.4);
                                            margin-right: 14px;
                                            user-select: none;
                                            cursor: pointer;

                                            i {
                                                display: block;
                                                width: 13px;
                                                height: 13px;
                                                background: url('./assets/add.png') no-repeat;
                                                background-size: 100% 100%;
                                                background-position: center center;
                                                margin-right: 9px;
                                            }

                                            span {
                                                font-size: 14px;
                                                color: #41B48C;
                                                font-weight: bold;
                                            }
                                        }

                                        &>span {
                                            font-size: 13px;
                                            color: #B9C3C3;
                                        }
                                    }

                                    .uploadProgress-container {
                                        display: flex;
                                        flex-direction: row;
                                        width: 100%;

                                        i {
                                            display: block;
                                            width: 16px;
                                            height: 16px;
                                            background: url('./assets/file.png') no-repeat;
                                            background-position: center center;
                                            background-size: 100% 100%;
                                            margin-top: 3px;
                                            margin-right: 4px;
                                        }

                                        .uploadProgress {
                                            display: flex;
                                            flex-direction: column;
                                            flex: 1;
                                            max-width: 330px;

                                            .top {
                                                width: 100%;
                                                height: 22px;
                                                display: flex;
                                                flex-direction: row;
                                                justify-content: space-between;
                                                align-items: center;

                                                .lt {
                                                    flex: 1;
                                                    font-size: 14px;
                                                    line-height: 22px;
                                                    color: #050F0F;
                                                    font-weight: 500;
                                                    white-space: nowrap;      /*超出的空白区域不换行*/
                                                    overflow: hidden;         /*超出隐藏*/
                                                    text-overflow: ellipsis;
                                                }

                                                .rt {
                                                    display: block;
                                                    width: 16px;
                                                    height: 16px;
                                                    background: url('./assets/del.png') no-repeat;
                                                    background-position: center center;
                                                    background-size: 100% 100%;
                                                    user-select: none;
                                                    cursor: pointer;
                                                }
                                            }

                                            .bottom {
                                                position: relative;
                                                width: 255px;
                                                height: 2px;
                                                background: rgba(0, 0, 0, 0.06);
                                                border-radius: 1px;
                                                overflow: hidden;
                                                margin-top: 4px;

                                                .g {
                                                    position: absolute;
                                                    top: 0;
                                                    left: 0;
                                                    width: 0%;
                                                    height: 100%;
                                                    background: #41B48C;
                                                    border-radius: 1px;
                                                }
                                            }
                                        }
                                    }

                                    &:nth-last-of-type(1) {
                                        margin-bottom: 0;
                                    }
                                }
                            }
                        }
                    }
                }
            }

            .btn {
                width: 120px;
                height: 40px;
                line-height: 40px;
                text-align: center;
                background: #41B48C;
                border-radius: 25px;
                font-size: 14px;
                color: #FFFFFF;
                margin: 20px auto 20px;
                user-select: none;
                cursor: pointer;
            }
        }
    }
</style>

<style lang="less">
.el-button--text {
    color: #41B48C !important;

    &:hover {
        color: #41B48C !important;
    }
}

.el-button.is-plain:focus, .el-button.is-plain:hover {
    color: #41B48C !important;
    border-color: #41B48C !important;
}

.el-picker-panel.no-atTheMoment {
    .el-button--text.el-picker-panel__link-btn {
        display: none;
    }
}
</style>